<!--<select [(ngModel)]="questionGroupId" (change)="questionGroupChanged()" required>
  <option value="0">--please select--</option>
  <option *ngFor="let questionGroup of questionGroups" [(ngValue)]="questionGroup.questionGroupId">{{questionGroup.name}}</option>
</select>-->


<ng-select #ngQuestionGroupsSelect class="questionGroupsSelector" [items]="questionGroups"
           bindLabel="name" autofocus bindValue="questionGroupId" [(ngModel)]="questionGroupId"
           placeholder={{getPlaceholderText()}} (change)="onQuestionGroupSelected()"
           (clear)="onQuestionGroupSelected()">
</ng-select>
